export default {
  config: {
    data_table_expire_days: 7,
  },
  tags: ["limited-to-microsoft", "limited-to-free"],
  api: [
    { rule: "lcagent.*", allow: false },
    { rule: "lcgroup.*", allow: false },
    { rule: "report.update", allow: false },
    { rule: "report.create", allow: false },
    { rule: "query.update", allow: false },
    { rule: "query.create", allow: false },
    { rule: ".*", allow: true },
  ],
  page: [
    { rule: "getstarted/.*", allow: true },
    { rule: "dashboard/responder", allow: false },
    { rule: "dashboard/manager", allow: false },
    { rule: "dashboard/security", allow: false },
    { rule: "dashboard/resources", allow: false },
    { rule: "dashboard/.*", allow: true },
    { rule: "settings/rules", allow: false },
    { rule: "settings/blocklists", allow: false },
    { rule: "settings/sensors", allow: false },
    { rule: "settings/subnets", allow: false },
    { rule: "settings/tags", allow: false },
    { rule: "settings/.*", allow: true },
    { rule: "reporting/popularreports", allow: false },
    { rule: "reporting/scheduledreports", allow: false },
    { rule: "reporting/.*", allow: true },
    { rule: "blumiraagent/.*", allow: false },
    { rule: "user/.*", allow: true },
  ],
  schema: [
    {
      rule: "user",
      properties: {
        configAlerts: {
          type: "object",
          properties: {
            voice_number: { type: "string", readOnly: true },
            text_number: { type: "string", readOnly: true },
          },
        },
      },
    },
  ],
};
